import Promise = require('bluebird');

export default function polyfillPromise(): void {
  if (!(window as any).Promise) {
    (window as any).Promise = Promise;
  }
}
